import { ISelectOption } from '../interfaces/select-option.interface';

export const ICON_STYLES_OPTIONS: ISelectOption[] = [
  { key: 'basic', name: 'Basic' },
  { key: 'outlined', name: 'Outlined' },
];
